export default "__VITE_ASSET__Bf$K9B$4__"